import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import action from './action/index';
import auth from './auth/index';
import pref from './pref/index';
import order from './order/index';
import layout from './layout/index';
import team from './team/index';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    action,
    auth,
    pref,
    order,
    layout,
    team,
  },
  plugins: [createPersistedState({
    key: 'nutricia-copacking',
    paths: [
      'auth',
      'pref',
      'order',
    ],
  })],
});
